import type { AnyRoute } from "@tanstack/react-router"
import { createFileRoute } from "@tanstack/react-router"

import PermissionContentWrapper from "@/components/PermissionWrapper/PermissionContentWrapper"
import { PermissionActionType } from "@/constants/permissions"
import { CompanyPreferencesTab } from "@/screens/Companies/edit/components/preferences/CompanyPreferencesTab"

export const Route: AnyRoute = createFileRoute("/app/companies/$companyId/edit/_layout/preferences")({
  component: () => (
    <PermissionContentWrapper
      permissions={[PermissionActionType.CUSTOMER_VIEW, PermissionActionType.CUSTOMER_MAINTENANCE]}
    >
      <CompanyPreferencesTab />
    </PermissionContentWrapper>
  ),
})
